<template>
  <v-dialog
    v-model="show"
    :max-width="max_width"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-file-input
              v-model="item.pdf_binary"
              accept=".pdf"
              show-size
              :label="$t('container.pdf')"
              :prepend-icon="''"
              append-icon="mdi-file-image-outline"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close">{{ $t("cancel") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="action != action_items.view"
          color="primary"
          :disabled="allowSave"
          @click="save"
        >{{ $t("save") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BaseDialog from "./BaseDialog";
export default {
  data: (vm) => ({
    topic: vm.$i18n.t("container.import-pdf"),
  }),
  computed: {
    allowSave() {
      return !(this.item.pdf_binary)
    },
  },
  mixins: [BaseDialog],
  methods: {},
};
</script>